
/**
 * These are media (MIME) types supported by the file download capability.
 */
export enum DownloadFileMediaType {
  TEXT_CSV = 'TEST/CSV',
  TEXT_PLAIN = 'TEXT/PLAIN'
  // TODO: Add others ...
}

/**
 * Character sets that can be applied
 */
export enum DownloadFileCharset {
  UTF_8 = 'UTF-8',
  US_ASCII = 'US-ASCII'
  // TODO: Add others ...
}

/**
 * Mapping of media (MIME) types to download file extensions
 */
export const TypeExtensionMap = new Map<DownloadFileMediaType, string>();
TypeExtensionMap.set(DownloadFileMediaType.TEXT_CSV, 'csv');
TypeExtensionMap.set(DownloadFileMediaType.TEXT_PLAIN, 'txt');
// TODO: Add others ...

/**
 * Interface for parameters that need to be provided to the download file
 * function.
 */
export interface DownloadFileParams {
  /**
   * The content of the file to download in string form. Base64 encoded data is
   * accepted, but the associated flag should be set to true if that is the
   * case.
   */
  content: string;

  /**
   * Media (MIME) type of the file. If not specified, then it is assumed to be
   * TEXT/PLAIN.
   */
  mediaType?: DownloadFileMediaType;

  /**
   * Name to use for the download file. If not specified, then a default is
   * provided.
   */
  downloadFileName?: string;
}
